import React from "react";
import {
  View,
  StyleSheet,
  SafeAreaView,
  ActivityIndicator,
  ImageBackground,
  Image,
} from "react-native";
import { Surface } from "react-native-paper";
// import Timer from "./timer";
import Quiz from "./index2";
import { connect } from "react-redux";
import {
  getTest,
  dispatchClearHomeInfo,
  clearTest,
  clearSubmitTestData,
  submitTest,
} from "../../store/actions";
// import BackHandlerAndroid from './../AndroidBackHandler';
// import {resetAll} from './../../navigators/navigationService';
// import Toast, {DURATION} from 'react-native-easy-toast'
// import LinearGradientComponent from './../HeaderBackgroundComponent';
// import StylesColors from './../Colors';
// import Icon from 'react-native-vector-icons/dist/Ionicons';
// import Icons from 'react-native-vector-icons/dist/FontAwesome';
// const isIos = Platform.OS === "ios";
// import OfflineHandler from './../OfflineHandler';
import { Text, Styles } from "./../../components/UI-Components";
import Icon from "@material-ui/core/Icon";
import QueryBuilderIcon from "@material-ui/icons/QueryBuilder";
import Container from "@material-ui/core/Container";
import Toaster from "./../../components/snackBar_toaster";
// import { Header } from "./../../components";
import { Header, TestInfoStrip, Timer,Button } from './../../components';
import './newQuizScreen/quiz.scss';
import QuestionComponent from './newQuizScreen/questionComponent';
import SelectedQuestions from './newQuizScreen/selectedQuestions';
import { withRouter } from 'react-router-dom';

const Loader = require("./../../assets/loadingGif.gif");

// import GestureRecognizer, {swipeDirections} from './../UI-Components/gestureRecogniseComponent';
class QuizContainer extends React.Component {
  state = {
    showToast: false,
    toasterMessage: "",
  };
  onBackButtonEvent(event) {
    event.preventDefault();                        
    window.location.pathname = '/Home';
    }

  componentDidMount() {
    // const {navigation} = this.props;
    // window.onpopstate = this.onBackButtonEvent
    const { history } = this.props;
    window.addEventListener("popstate", () => {
      history.push('/Home');
    });
    const { state } = this.props.location || {};
    const { isTestSeries, testId = null } = state || {};


    if (testId) {
      this.props.getTest(testId, false, isTestSeries);
    }
    // this.props.startTest();
  }

  componentWillUnmount() {
    // window.onpopstate = () => {
    //   this.props.history
    // }
    this.props.clearTest();
    this.props.clearSubmitTestData();
  }

  shouldComponentUpdate(prevProps) {
    if (
      prevProps.testInfo &&
      !prevProps.testInfo.loading &&
      prevProps.testInfo.test
    ) {
      if (
        (prevProps.testInfo.questionsInfo &&
          prevProps.testInfo.questionsInfo.length > 0) ||
        prevProps.testInfo.selectedAnswers ||
        prevProps.testInfo.activeQuestion > 0 ||
        prevProps.testInfo.touched
      ) {
        return false;
      }
      return true;
    }
    return true;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.error !== this.props.error) {
      if (this.props.error) {
        let text = `${this.props.errMessage || "Your test time is completed"} ${
          this.props.remainingTime || ""
        }`;
        this.showToaster(text, 1500, () => {
          this.props.history.push("/Home");
        });
      }
    }

    if (prevProps.errInfo !== this.props.errInfo) {
      if (this.props.errInfo) {
        if (this.props.errInfo === "Unauthenticated.") {
          this.props.dispatchClearHomeInfo();
          setTimeout(() => {
            // resetAll(this.props.navigation, 'Home');
          }, 500);
        }
      }
    }
    if(prevProps.testInfo !== this.props.testInfo){
      if(this.props.testInfo){
        if(!(this.props.testInfo && this.props.testInfo.length > 0)){
          // this.props.history.push('/Home')
        }
      }
    }
  }

  submitTestIfBackPress = () => {
    // const isPlannedTest = this.props.navigation.getParam('plannedTest', false);
    // const isTestSeries = this.props.navigation.getParam('isTestSeries', false);
    const { state } = this.props.location || {};
    const { plannedTest = false, isTestSeries } = state || {};
    this.props.submitTest(plannedTest, isTestSeries);
  };

  showToaster = (msg, time, callback) => {
    this.setState({
      showToast: true,
      toasterMessage: msg,
    });
  };

  onSwipeLeft = (gestureState) => {
    // this.setState({myText: 'You swiped left!'});
    alert("");
  };

  onSwipeRight = (gestureState) => {
    alert("");
    this.setState({ myText: "You swiped right!" });
  };
    
  openSubmit = () => {

  }

  render() {
    console.log(this.quiz, 'ref');
    const {
      loading,
      testInfo,
      testDuration,
      error,
      testStartRemainingTime,
    } = this.props;
    // console.log(testInfo, "sdfllsdf");
    const config = {
      velocityThreshold: 0.3,
      directionalOffsetThreshold: 80,
    };
    return (
      <>
           <Header />
                <div className='w-100 quiz'>
                    <div className='container-fluid p-0 '>
                        <div className='row mx-2'>
                            <div className='col-lg-9 col-12 py-2'>
                                <div className='container-fluid my-4'>
                                    <div className='topComponent col-12 p-0'>
                                        <TestInfoStrip
                                            width={300}
                                            height={48}
                                            title={`Questions`}
                                            color={'#000'}
                                            size={20}
                                            fontWeight={600}
                                            padding={10}
                                        />
                                        <div>
                                            <Timer
                                                size={80}
                                                duration={parseInt(testStartRemainingTime, 10) / 60 ||
                                                parseInt(120000, 10) / 60}
                                            />
                                        </div>
                                    </div>
                                    <Quiz ref={this.quiz} />
                                  
                                </div>

                            </div>
                            <div className='col-lg-3 col-12 question_select py-4'>
                               <div>
                                    <SelectedQuestions data={testInfo?.test} />
                               </div>
                            </div>
                        </div>

                    </div>
                </div>
        {/* <Header
          title={testInfo?.title}
       
        /> */}
        {/* {loading ? (
          <View
            style={{
              width: "100%",
              height: "90vh",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#fff",
            }}
          >
       
            <Image source={Loader} style={{ width: 250, height: 250 }} />
          </View>
        ) : null}
        {!loading && (
          <Container maxWidth="lg">
            <div className="main-component">
              {!loading &&
              !error &&
              testInfo &&
              testInfo.test &&
              testInfo.test.length ? (
                <div
                  className="exam-component"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    paddingBottom: 7,
                  }}
                >
                  <View style={styles.flexRowBetween}>
                    <Timer
                      digitStyles={{fontSize:18}}
                      timer={
                        parseInt(testStartRemainingTime, 10) / 60 ||
                        parseInt(120000, 10) / 60
                      }
                      onSubmit={this.submitTestIfBackPress}
                      inSeconds={testStartRemainingTime ? true : false}
                      size={15}
                      hours={true}
                    />
                   
                    <View style={{ marginLeft: 12 }}>
                      <QueryBuilderIcon
                        style={{
                          marginRight: 8,
                          color: "#F5591F",
                          width: 22,
                          height: 22,
                        }}
                        size={22}
                      />
                    </View>
                  </View>
                  <View style={{ flex: 1 }}>
                    <Quiz />
                  </View>
                </div>
              ) : null} */}

              {/* {
                        !loading && error && <Text style={{marginLeft:30, marginBottom:30,color:"#222"}}>{this.props.errInfo || this.props.errMessage|| 'something went wrong...'}</Text>
                    } */}
              {/* <Toast 
                        ref="toast" 
                        style={{backgroundColor: '#fff', 
                        color:'#222', borderRadius: 50}} 
                        textStyle={{color: '#222'}} 
                        positionValue={160}
                        position={'bottom'}
                    /> */}

            
            {/* </div>
          </Container> */}
        {/* )} */}
        <Toaster
            show={this.state.showToast}
            message={this.state.toasterMessage}
          />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.testInfo && state.testInfo.loading,
  testInfo: state.testInfo && state.testInfo,
  testDuration:
    state.testInfo &&
    state.testInfo.testDuration &&
    state.testInfo.testDuration,
  testStartRemainingTime:
    state.testInfo &&
    state.testInfo.totalResponse &&
    state.testInfo.totalResponse.status &&
    state.testInfo.totalResponse.status.time_remaining,
  error: state.testInfo && state.testInfo.error,
  errInfo:
    state.testInfo &&
    state.testInfo.errorInfo &&
    state.testInfo.errorInfo.response,
  errMessage:
    state.testInfo &&
    state.testInfo.errorInfo &&
    state.testInfo.errorInfo.response &&
    state.testInfo.errorInfo.response.data &&
    state.testInfo.errorInfo.response.data.message,
  remainingTime:
    state.testInfo &&
    state.testInfo.errorInfo &&
    state.testInfo.errorInfo.response &&
    state.testInfo.errorInfo.response.data &&
    state.testInfo.errorInfo.response.data["time Remaining"],
});

const styles = StyleSheet.create({
  flexRowBetween: {
    justifyContent: "flex-end",
    alignItems: "center",
    flexDirection: "row",
    backgroundColor: "#fff",
    fontSize: 12,
    marginTop: 10,
    paddingHorizontal: 10,
  },
});

export default connect(mapStateToProps, {
  getTest,
  dispatchClearHomeInfo,
  clearTest,
  clearSubmitTestData,
  submitTest,
})(withRouter(QuizContainer));
